import { render } from "./EditDocumentPage.vue?vue&type=template&id=0b43294c&ts=true"
import script from "./EditDocumentPage.vue?vue&type=script&lang=ts"
export * from "./EditDocumentPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__